import { render, staticRenderFns } from "./GeneralErrorPage.vue?vue&type=template&id=41ff224a"
import script from "./GeneralErrorPage.vue?vue&type=script&lang=js"
export * from "./GeneralErrorPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports